import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-b from-[var(--color-background)] to-[var(--color-card)] py-6 overflow-hidden">
      {/* Decorative circles */}
      <div className="absolute top-10 right-10 w-32 h-32 md:w-48 md:h-48 lg:w-64 lg:h-64 rounded-full border-2 border-[var(--color-primary)]/20 animate-pulse" />
      <div className="absolute bottom-10 left-10 w-24 h-24 md:w-36 md:h-36 lg:w-48 lg:h-48 rounded-full border-2 border-[var(--color-accent)]/20 animate-pulse" style={{ animationDelay: '1s' }} />

      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          {/* Animated logo */}
          <div className="inline-flex items-center justify-center mb-8">
            <div className="relative w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-accent)] flex items-center justify-center">
                <Icon name="Circle" size={40} color="white" className="md:w-16 md:h-16 lg:w-20 lg:h-20" />
              </div>
              <div className="absolute inset-0 rounded-full border-2 border-[var(--color-primary)] animate-ping opacity-75" />
              <div className="absolute inset-0 rounded-full border-2 border-[var(--color-accent)] animate-ping opacity-50" style={{ animationDelay: '1s' }} />
            </div>
          </div>
          <p className="text-lg md:text-xl lg:text-2xl text-[var(--color-muted-foreground)] leading-relaxed font-body italic">
            نغرّد داخل السرب؛ آملين أن تنبُتَ للجميع أجنحة.
          </p>
        </div>
      </div>
    </section>);

};

export default HeroSection;